import {type ConsoleAgentT} from './auth-helpers'
import {getEnvironment} from '@frontrow/console/src/entities/environment'

interface PendoConfig {
  visitor: {
    id: string
    email: string
    visitor_id_type: string
    user_type: string
    app_fr: string
    email_verified_fr: boolean
    groups_fr: string
  }
}

declare global {
  interface Window {
    pendo: {
      initialize: (config: PendoConfig) => void
      updateOptions: (config: PendoConfig) => void
      track: (name: string, payload: object) => void
    }
  }
}

export function initializePendo(agent: ConsoleAgentT) {
  const environment = getEnvironment()

  if (environment === 'staging' || environment === 'test' || environment === 'localhost') {
    return
  }

  const tagEnvironment = (value: string | number): string => {
    const env = environment === 'production' ? '' : 'dev-'
    return `${env}${value}`
  }

  const visitorId = tagEnvironment(agent.email)

  window.pendo.initialize({
    visitor: {
      id: visitorId,
      email: agent.email,

      visitor_id_type: 'email',
      user_type: 'console_agent',

      app_fr: 'console',
      email_verified_fr: agent.verified,
      groups_fr: agent.groups.join(',')
    }
  })
}
